export default __webpack_public_path__ + "static/media/blog.28474238.svg";